// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"64":"editEvent","594":"inspiration"}[chunkId] + "." + {"64":"95cdf96f32e0f59fcbf2","594":"c847488db02ce080359b"}[chunkId] + ".bundle.js";
};